import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, Form, TreeSelect, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    checkInDate: any
    bornDate: any,
    birthDate: any,
    channel_id: undefined | string,
    deal_store_id: undefined | string,
    check_in_store_id: undefined | string,
    item_id: undefined | string,
    check_in_user_name: undefined | string,
    check_in_phone: undefined | string,
    check_in_status: number | undefined,
    room_number: string | undefined,
    inDate: any
    checkDate: any
    handleDate: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type department = {
    "item_id": string,
    "room_type_name": string
}

type fromItem = {
    id: string,
    channel_name: string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        checkInDate: null,
        bornDate: null,
        birthDate: null,
        checkDate: null,
        channel_id: undefined,
        check_in_store_id: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        item_id: undefined,
        deal_store_id: undefined,
        check_in_status: undefined,
        room_number: undefined,
        inDate: null,
        handleDate: null
    }

    const [form] = Form.useForm()

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [bmData, setBmData] = useState<department[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    const [selectNameData, setSelectNameData] = useState<project[]>([])
    const [fromItemData, setFromItemData] = useState<fromItem[]>([])

    const [addVisible, setAddVisible] = useState<boolean>(false)
    const [activeID, setActiveID] = useState<string | undefined>(undefined)

    const [consumeVisible, setConsumeVisible] = useState<boolean>(false)
    const [consumeData, setConsumeData] = useState<any>({})

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        // 查询月子套餐列表
        baseAxiosNoInfo('/global/item_list', { params: { item_type: 3 } }).then((res: any) => {
            res && setSelectNameData(res)
        })

        // 查询房型列表
        baseAxiosNoInfo('/keeper/room/type/list').then((res: any) => {
            res && setBmData(res)
        })

        // 查询渠道来源列表
        baseAxiosNoInfo('/finance_center/global/channel_source_list').then((res: any) => {
            res && setFromItemData(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'bornDate', ['start_expect_born_day', 'end_expect_born_day'])
        handleDate(params, 'birthDate', ['start_birth_day', 'end_birth_day'])

        handleDate(params, 'inDate', ['current_check_in_start_day', 'current_check_in_end_day'])
        handleDate(params, 'checkInDate', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkDate', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/keeper/data_report/customer_info_scan/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'bornDate', ['start_expect_born_day', 'end_expect_born_day'])

        handleDate(params, 'inDate', ['current_check_in_start_day', 'current_check_in_end_day'])
        handleDate(params, 'checkDate', ['check_out_start_day', 'check_out_end_day'])
        handleDate(params, 'checkInDate', ['check_in_start_day', 'check_in_end_day'])

        baseAxiosComplete('/keeper/data_report/customer_info_scan/export', {
            params: {
                ...iPagination,
                ...params
            }
        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    type project = {
        id: string
        item_name: string
    }

    let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))
    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    const initForm = {
        item_id: undefined,
        store_id: undefined,
        item_old_price: undefined,
        item_latest_price: undefined,
        order_level: undefined
    }

    const onFinish = (values: any) => {
        if (activeID) {
            values.check_in_id = activeID
        }

        baseAxiosComplete.post('/keeper/data_report/customer_info_scan/update', {
            ...values
        }).then(res => {
            if (res.status === 0) {
                setAddVisible(false)
                form.setFieldsValue(initForm)
                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 数据报表 -> 客户信息一览表 */}
        <BreadCrumb position={['管家中心', '客户信息一览表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores
                        placeholder="签单门店"
                        value={fetchOtherParams.deal_store_id}
                        onChange={(v: string) => {
                            handleChange(v, 'deal_store_id')

                            // 查询责任部门
                            baseAxiosNoInfo('/global/first_level_dep_of_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setBmData(res)
                            })
                        }}
                    />
                </div>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 230 }}
                    placeholder="签单套餐"
                    value={fetchOtherParams.item_id}
                    onChange={(v: string) => { handleChange(v, 'item_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                    {ItemNameOptions}
                </Select>
                <TreeSelect
                    showSearch
                    className="fl"
                    allowClear
                    virtual={false}
                    value={fetchOtherParams.channel_id}
                    treeData={recursionChildren(fromItemData)}
                    placeholder="来源渠道"
                    style={{ marginRight: 8, marginBottom: 12, width: 220 }}
                    onChange={(v: any) => {
                        handleChange(v, 'channel_id')
                    }}
                    filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
                />

                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores
                        placeholder="入住门店"
                        value={fetchOtherParams.check_in_store_id}
                        onChange={(v: string) => {
                            handleChange(v, 'check_in_store_id')
                        }}
                    />
                </div>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="入住状态" value={fetchOtherParams.check_in_status} onChange={(v: number) => { handleChange(v, 'check_in_status') }}>
                    <Option value={0} key={0}>待分配</Option>
                    <Option value={1} key={1}>已预订</Option>
                    <Option value={2} key={2}>已入住</Option>
                    <Option value={3} key={3}>已出所</Option>
                    <Option value={4} key={4}>跨店转入待分配</Option>
                    <Option value={5} key={5}>跨店转出</Option>
                    <Option value={6} key={6}>客户退单</Option>
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["入住开始日期", "入住结束日期"]} value={fetchOtherParams.checkInDate} onChange={(v: any) => { handleChange(v, 'checkInDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["在住开始日期", "在住结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["出所开始日期", "出所结束日期"]} value={fetchOtherParams.checkDate} onChange={(v: any) => { handleChange(v, 'checkDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12 }} className="fl" placeholder={["预产期开始日期", "预产期结束日期"]} value={fetchOtherParams.bornDate} onChange={(v: any) => { handleChange(v, 'bornDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["生日开始日期", "生日结束日期"]} value={fetchOtherParams.birthDate} onChange={(v: any) => { handleChange(v, 'birthDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table rowKey="check_in_id" loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="操作" fixed render={(v: any) => {
                    return permission.includes('编辑') ? <Button size="small" onClick={() => {
                        form.setFieldsValue({
                            agreement_code: v.agreement_code,
                            check_in_id_card: v.check_in_id_card,
                            check_in_birthday: v.check_in_birthday ? moment(v.check_in_birthday) : null,
                            born_hospital: v.born_hospital,
                            family_address: v.family_address,
                            born_way: v.born_way,
                            nursing_care_type: v.nursing_care_type,
                        })

                        setActiveID(v.check_in_id)
                        setAddVisible(true)
                    }}>编辑</Button> : null
                }} />

                <Column title="客户姓名" fixed dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="手机号码" fixed dataIndex="check_in_phone" key="check_in_phone" />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />
                <Column title="分娩日期" dataIndex="actually_born_day" key="actually_born_day" />
                <Column title="客户身份证" dataIndex="check_in_id_card" key="check_in_id_card" />
                <Column title="客户生日" dataIndex="check_in_birthday" key="check_in_birthday" />

                <Column title="合同编号" dataIndex="agreement_code" key="agreement_code" />
                <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="合同收款" dataIndex="agreement_pay_amount" key="agreement_pay_amount" />
                <Column title="合同尾款" dataIndex="left_amount" key="left_amount" />

                {/*
                <Column title="续住收款" dataIndex="continue_pay_amount" key="continue_pay_amount" />
                <Column title="其他收款" dataIndex="other_pay_amount" key="other_pay_amount" />
                <Column title="退款" dataIndex="refund_amount" key="refund_amount" />
                <Column title="总消费金额" dataIndex="total_pay_amount" key="total_pay_amount" />
                */}

                <Column title="总消费金额" render={(v: any) => {
                    return (<Button onClick={() => {
                        baseAxiosNoInfo('/keeper/data_report/customer_info_scan/consume_records', {
                            params: {
                                customer_id: v.customer_id
                            }

                        }).then((res: any) => {
                            res && setConsumeData(res)
                        })

                        setConsumeVisible(true)
                    }} type="dashed" size="small">{v.total_pay_amount}</Button>)
                }} />

                <Column title="客户来源" dataIndex="channel_name" key="channel_name" />
                <Column title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="签单套餐" dataIndex="item_name" key="item_name" />
                <Column title="签单销售" dataIndex="deal_sales_name" key="deal_sales_name" />
                <Column title="签单备注" dataIndex="deal_record_remakr" key="deal_record_remakr" />

                <Column title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column title="入住总天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
                <Column title="入住信息" dataIndex="room_number" key="room_number" />
                <Column title="入住日期" dataIndex="check_in_time" key="check_in_time" />
                <Column title="出所日期" dataIndex="check_out_time_finally" key="check_out_time_finally" />
                <Column title="护理类型" dataIndex="nursing_care_type_desc" key="nursing_care_type_desc" />
                <Column title="责任管家" dataIndex="belong_minion_name" key="belong_minion_name" />

                <Column title="分娩医院" dataIndex="born_hospital" key="born_hospital" />
                <Column title="分娩方式" dataIndex="born_way_desc" key="born_way_desc" />
                <Column title="家庭住址" dataIndex="family_address" key="family_address" />
            </Table>
        </div>

        <Modal title={"编辑"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="500px">
            <Form {...formItemLayout} form={form} name="validate_other" onFinish={onFinish} >
                <Form.Item label="客户身份证" name="check_in_id_card"  >
                    <Input />
                </Form.Item>
                <Form.Item label="客户生日" name="check_in_birthday"  >
                    <DatePicker />
                </Form.Item>

                <Form.Item label="合同编号" name="agreement_code"  >
                    <Input />
                </Form.Item>
                <Form.Item label="护理类型" name="nursing_care_type"  >
                    <Select virtual={false}  >
                        <Option value={0}>未知</Option>
                        <Option value={1}>一对一</Option>
                        <Option value={2}>托管</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="分娩医院" name="born_hospital"  >
                    <Input />
                </Form.Item>
                <Form.Item label="分娩方式" name="born_way"  >
                    <Select virtual={false}  >
                        <Option value={0}>未知</Option>
                        <Option value={1}>顺产</Option>
                        <Option value={2}>剖腹产</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="家庭住址" name="family_address"  >
                    <Input />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 客户消费记录弹窗 */}
        <Modal title="客户消费记录" visible={consumeVisible} footer={false} onCancel={() => { setConsumeVisible(false) }} width={550}>
            <Form {...formItemLayout} style={{ padding: '15px' }} >
                <Form.Item label="月子合同金额" >{consumeData.yuezi_agreement_amount}</Form.Item>
                <Form.Item label="月子收款" >{consumeData.yuezi_pay_amount}</Form.Item>
                <Form.Item label="月子续住收款" >{consumeData.yuezi_continue_amount}</Form.Item>
                <Form.Item label="月子其他收款" >{consumeData.yuezi_other_amount}</Form.Item>
                <Form.Item label="月子退款" >{consumeData.yuezi_refund_amount}</Form.Item>
                <Form.Item label="产康收款" >{consumeData.chankang_pay_amount}</Form.Item>
                <Form.Item label="产康消耗金额" >{consumeData.chankang_consume_amount}</Form.Item>
                <Form.Item label="产康未消耗金额" >{consumeData.chankang_not_consume_amount}</Form.Item>
                <Form.Item label="产康退款" >{consumeData.chankang_refund_amount}</Form.Item>
            </Form>
        </Modal>
    </div>)
}